import React from 'react';
import { Handle, Position } from 'reactflow';



const ToolCallNode = ({ data }) => {
  const { tool, args, status, result, error, executionTime } = data;
  
  // Choose color based on status
  const getBorderColor = () => {
    switch (status) {
      case 'processing': return '#faad14';
      case 'success': return '#52c41a';
      case 'error': return '#ff4d4f';
      default: return '#6941c6';
    }
  };
  
  return (
    <div style={{
      padding: '8px',
      border: `2px solid ${getBorderColor()}`,
      borderRadius: '8px',
      background: '#fff',
      width: '220px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      position: 'relative',
      transition: 'all 0.2s ease-in-out',
    }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#6941c6', width: '8px', height: '8px' }}
      />
      
      {/* Header */}
      <div style={{
        padding: '8px',
        borderBottom: '1px solid #f0f0f0',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span style={{ fontSize: '16px', marginRight: '4px' }}>🔌</span>
        <div style={{ 
          fontSize: '13px', 
          fontWeight: '600', 
          color: '#1f1f1f', 
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {tool?.name || 'Tool Call'}
        </div>
        <div style={{
          fontSize: '10px',
          padding: '2px 6px',
          background: '#f0f9ff',
          color: '#0369a1',
          borderRadius: '4px',
          marginLeft: 'auto'
        }}>
          {status === 'processing' ? 'Running...' : (executionTime || '')}
        </div>
      </div>
      
      {/* Content */}
      <div style={{ padding: '8px' }}>
        <div style={{ fontSize: '11px', fontWeight: '500', color: '#6b7280', marginBottom: '4px' }}>
          Function: <span style={{ fontFamily: 'monospace', color: '#4b5563' }}>{tool?.function?.name || 'unknown'}</span>
        </div>
        
        {/* Args */}
        <div style={{ marginBottom: '8px' }}>
          <div style={{ fontSize: '11px', fontWeight: '500', color: '#6b7280', marginBottom: '2px' }}>
            Arguments:
          </div>
          <div style={{ 
            background: '#f9fafb', 
            padding: '4px 6px', 
            borderRadius: '4px', 
            maxHeight: '50px', 
            overflow: 'auto',
            fontSize: '10px',
            fontFamily: 'monospace',
            color: '#4b5563'
          }}>
            {JSON.stringify(args, null, 1)}
          </div>
        </div>
        
        {/* Results or Error */}
        {(status === 'success' || status === 'error') && (
          <div>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#6b7280', marginBottom: '2px' }}>
              {status === 'success' ? 'Result:' : 'Error:'}
            </div>
            <div style={{ 
              background: status === 'success' ? '#f0fdf4' : '#fff1f0', 
              padding: '4px 6px', 
              borderRadius: '4px', 
              maxHeight: '50px', 
              overflow: 'auto',
              fontSize: '10px',
              fontFamily: 'monospace',
              color: status === 'success' ? '#16a34a' : '#dc2626'
            }}>
              {status === 'success' 
                ? JSON.stringify(result, null, 1) 
                : error}
            </div>
          </div>
        )}
        
        {/* Processing spinner */}
        {status === 'processing' && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            padding: '12px 0',
            color: '#6941c6'
          }}>
            <div className="spinner"></div>
            <style>{`
              .spinner {
                width: 16px;
                height: 16px;
                border: 2px solid rgba(105, 65, 198, 0.2);
                border-top: 2px solid #6941c6;
                border-radius: 50%;
                animation: spin 1s linear infinite;
              }
              
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        )}
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: status === 'success' ? '#16a34a' : (status === 'error' ? '#ff4d4f' : '#6941c6'), width: '8px', height: '8px' }}
      />
    </div>
  );
};

export default ToolCallNode;